import React from "react";
import Municipality from "./Municipality";
import Ant from "./Ant";
import {Person} from "../../../services/interface/query/person";

interface Props {
    person?: Person;
}
export default function Debts({person}: Props): JSX.Element {
    return(
        <div className={'flex flex-col gap-3'}>
            <Municipality {...{person}}/>
            <Ant {...{person}}/>
        </div>
    )
}
